document.addEventListener("DOMContentLoaded", () => {
  let state = {};

  const customizeBtn = document.getElementById("ocbCustomizeBtn");
  const DEFAULT_URL = "/pages/sports-collection";

 function updateCustomizeButton() {
    if (!customizeBtn) return;

    const baseDomain = window.location.origin;
    customizeBtn.removeAttribute("disabled");

    customizeBtn.onclick = () => {

      if (state.segment && !state.industry && !state.apparel) {
        window.location.href = `${baseDomain}/collections/cricket-uniforms`;
        return;
      }

      let baseCollectionUrl = "";
      let tags = [];

      const isCricketUniform = state.segment?.includes("cricket");

      if (state.segment === "cricket-uniform") {
        baseCollectionUrl = `${baseDomain}/collections/cricket-uniforms`;
      } else {
        baseCollectionUrl = `${baseDomain}/collections/custom-sportswear`;
      }

      if (isCricketUniform) {

        if (!state.industry) {
          alert("Please select Featured option");
          return;
        }

        tags.push("sports-cricket");

        if (state.industry && state.apparel) {

          if (['cap','hat','clads'].includes(state.apparel)) {
            tags.push(`accessories-cricket-${state.apparel}`);
          } else if(state.industry==="clothing") {
            tags.push(`clothing-cricket-${state.apparel}`);
          }else if (state.industry === "athleisure"){
            tags.push(`athleisure-cricket-${state.apparel}`);
          }

        }

      } else {

        if (state.industry) {
          tags.push(`sports-${state.industry}`);
        }

        if (state.apparel) {

          if (['cap','hat'].includes(state.apparel)) {
            tags.push(`accessories-${state.industry}-${state.apparel}`);
          } else {
            tags.push(`clothing-${state.industry}-${state.apparel}`);
          }

        }

      }

      const finalUrl = tags.length
        ? `${baseCollectionUrl}/${tags.join("+")}`
        : baseCollectionUrl;

      window.location.href = finalUrl;
    };
  }

  /* ----------------------------------
       HELPERS
    ---------------------------------- */
  function populate(menu, items) {
    menu.innerHTML = "";
    Object.values(items).forEach((item) => {
      const li = document.createElement("li");
      li.textContent = item.title;
      li.dataset.url = item.url;
      li.dataset.handle = item.handle;
      menu.appendChild(li);
    });
  }

  function enable(level) {
    document
      .querySelector(`[data-level="${level}"] .ocb-trigger`)
      .removeAttribute("disabled");
  }

  function reset(level) {
    const trigger = document.querySelector(
      `[data-level="${level}"] .ocb-trigger`
    );
    trigger.querySelector(".ocb-trigger-text").textContent =
      "Select " + level.charAt(0).toUpperCase() + level.slice(1);
    trigger.setAttribute("disabled", true);
    document.querySelector(`[data-level="${level}"] .ocb-menu`).innerHTML = "";
    delete state[level];
  }

  function updateIndustryLabel(segmentHandle) {
    const field = document.querySelector('[data-level="industry"]');
    if (!field) return;

    const label = field.querySelector(".ocb-dynamic-label");
    const triggerText = field.querySelector(".ocb-trigger-text");

    const config = {
      "custom-sportswear": {
        label: "Sport",
        placeholder: "Select Sport",
      },
      "cricket-uniform": {
        label: "Featured",
        placeholder: "Select Featured",
      },
    };

    const values = config[segmentHandle] || {
      label: "Industry",
      placeholder: "Select Industry",
    };

    label.textContent = values.label;
    triggerText.textContent = values.placeholder;
  }

  /* ----------------------------------
       DROPDOWN DIRECTION LOGIC
    ---------------------------------- */
  document.querySelectorAll(".ocb-dropdown").forEach((dropdown) => {
    const trigger = dropdown.querySelector(".ocb-trigger");
    const menu = dropdown.querySelector(".ocb-menu");

    dropdown.addEventListener("mouseenter", () => {
      if (trigger.hasAttribute("disabled")) return;

      menu.style.visibility = "hidden";
      menu.style.display = "block";

      const triggerRect = trigger.getBoundingClientRect();
      const spaceBelow = window.innerHeight - triggerRect.bottom;
      const menuHeight = menu.offsetHeight;

      menu.style.display = "";
      menu.style.visibility = "";

      dropdown.classList.toggle("ocb-dropdown-up", spaceBelow < menuHeight);
      dropdown.addEventListener("mouseenter", () => {
        // Allow dropdown to open again on re-hover
        dropdown.classList.remove("ocb-locked");
      });
    });
  });

  /* ----------------------------------
       MENU CLICK HANDLING
    ---------------------------------- */
  document.querySelectorAll(".ocb-menu").forEach((menu) => {
    menu.addEventListener("click", (e) => {
      const li = e.target.closest("li");
      if (!li) return;

      const field = li.closest(".ocb-field");
      const level = field.dataset.level;
      const trigger = field.querySelector(".ocb-trigger");

      trigger.querySelector(".ocb-trigger-text").textContent = li.textContent;
      trigger.dataset.url = li.dataset.url;

      if (level === "segment") {
        state.segment = li.dataset.handle;

        updateIndustryLabel(state.segment);

        populate(
          document.querySelector('[data-level="industry"] .ocb-menu'),
          ocbData[state.segment].children
        );

        enable("industry");
        reset("apparel");
      }

      if (level === "industry") {
        state.industry = li.dataset.handle;

        populate(
          document.querySelector('[data-level="apparel"] .ocb-menu'),
          ocbData[state.segment].children[state.industry].children
        );

        enable("apparel");
      }

      if (level === "apparel") {
        state.apparel = li.dataset.handle;
      }

      updateCustomizeButton();

      const dropdown = field.querySelector(".ocb-dropdown");
      dropdown.classList.add("ocb-locked");

      // Hide menu immediately
      const menu = dropdown.querySelector(".ocb-menu");
      menu.style.display = "none";
    });
  });

  /* ----------------------------------
       DEFAULT SEGMENT SELECTION
    ---------------------------------- */
  const defaultSegmentHandle = "custom-sportswear";

  if (window.ocbData && ocbData[defaultSegmentHandle]) {
    state.segment = defaultSegmentHandle;

    const segmentTrigger = document.querySelector(
      '[data-level="segment"] .ocb-trigger'
    );

    segmentTrigger.querySelector(".ocb-trigger-text").textContent =
      ocbData[defaultSegmentHandle].title;

    segmentTrigger.dataset.url = ocbData[defaultSegmentHandle].url;

    updateIndustryLabel(defaultSegmentHandle);

    populate(
      document.querySelector('[data-level="industry"] .ocb-menu'),
      ocbData[defaultSegmentHandle].children
    );

    enable("industry");
    reset("apparel");
  }

  updateCustomizeButton();
});
